import React, { useState } from 'react';
import Svg from '../shared/Svg';
import colors from '../../utils/colors';
import { handleLogout } from '../../utils/auth';
import { useDispatch } from 'react-redux';
import './UninterruptedModeBanner.scss';

export const UninterruptedModeBanner = () => {
  const dispatch = useDispatch();
  const [hideBanner, setHideBanner] = useState(false);

  const onLogoutClicked = async () => {
    setHideBanner(true);
    await handleLogout(dispatch);
  };

  return (
    <>
      {!hideBanner && <div className='uninterrupted-mode-banner-container'>
        <div>
          <strong className='uninterrupted-mode-banner-header'>You are in Uninterrupted Mode.</strong>
          <p className='uninterrupted-mode-banner-subheader'>Please <u onClick={onLogoutClicked}>log in</u> to the add-in</p>
        </div>
        <div className='uninterrupted-mode-banner-dismiss'>
          <Svg
            className="searchTableItem-closeIcon"
            data="../../../../assets/close.svg"
            fill={colors.bannerBlue}
            onClickAction={() => setHideBanner(true)}
            hoverable
            hoverFill={colors.iconHover}
          />
        </div>
      </div> }
    </>
  );
};
